// @flow
import moment from 'moment';

export const US_DATE = 'YYYY-MM-DD';
export const BR_DATE = 'DD/MM/YYYY';
export const BR_DATE_TIME = 'DD/MM/YYYY, HH:mm';
export const BR_DATE_TIME_SECONDS = 'DD/MM/YYYY, HH:mm:ss';

export function formatUSDate(date: Date): string {
  if (!date) {
    return '';
  }
  return moment(date).format(US_DATE);
}

export function formatBRDate(date: Date): string {
  if (!date) {
    return '';
  }
  return moment(date).format(BR_DATE);
}

export function formatBRDateTime(date: Date): string {
  if (!date) {
    return '';
  }
  return moment(date).format(BR_DATE_TIME);
}

export function formatBRDateTimeSecs(date: Date): string {
  if (!date) {
    return '';
  }
  return moment(date).format(BR_DATE_TIME_SECONDS);
}

export function validateDate(date: Date): Boolean {
  if (!date) {
    return '';
  }
  return moment(date).isValid();
}
